// extracted by mini-css-extract-plugin
module.exports = {"container":"InlineNameEdit_container_1_vQf","headline":"InlineNameEdit_headline_2Dnxo","nameInput":"InlineNameEdit_nameInput_mMGgl","subtitle":"InlineNameEdit_subtitle_227Od"};